import { Component, OnInit, AfterViewInit, NgZone, Inject, Input, ViewChild, Optional } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet, ParamMap } from "@angular/router";
import { ApiService } from '../../api.service';
import { combineLatest, merge, of, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
declare var $: any;
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { environment } from '../../../environments/environment';
import { DOCUMENT } from '@angular/common';
import { debounceTime, distinctUntilChanged, map, switchMap, tap, withLatestFrom } from "rxjs/operators";
import { slideInAnimation } from '../../animations/route-animation';
import moment from 'moment';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { NavbarComponent } from '../../navbar/navbar.component';

@Component({
	selector: 'app-mail-list',
	templateUrl: './mail-list.component.html',
	styleUrls: ['./mail-list.component.scss', '../../../assets/styles/mailbox.scss'],
	animations: [slideInAnimation]
})
export class MailListComponent implements OnInit, AfterViewInit {
	mailCnt: number = 0;
	category: string = "";
	mailList: any[] = [];
	mailStart: number = 1;
	mailLimit: number = 10;
	isListFinished: boolean = false;
	isListLoading: boolean = false;
	showSelectMailMsg: boolean = true;
	formCtrlSub!: Subscription;
	searchControl: FormControl = new FormControl(null);
	unreadCountIncrementSubscription!: Subscription;
	allChecked = false;
	/* spammoduleAccess = "Full";
	moduleAccess = "Full"; */
	loaderMoveMail = false;
	apptId: any = null;
	followUpId: any = null;
	mailboxReadonly = true;
	@ViewChild(CdkVirtualScrollViewport, { static: false }) viewport!: CdkVirtualScrollViewport;

	constructor(private apiService: ApiService, private router: Router, private activeRoute: ActivatedRoute, private toastr: ToastrService, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) {
		this.apiService.getCountChangeEvent().subscribe(() => {
			this.getMailCount();
			this.refreshMails(true);
		});
		if (localStorage.getItem("usertype") == "Company") {
			this.mailboxReadonly = true;
		} else {
			this.mailboxReadonly = false;
		}
	}

	ngOnInit(): void {
		combineLatest([
			this.activeRoute.parent?.paramMap ?? of(null),
			this.activeRoute.paramMap
		]).pipe(
			tap(([parentMap, childMap]) => {
				let refresh = false;
				let folder = childMap?.get('folder') || '';
				let uId = parentMap?.get('uId') || '';
				try {
					if (uId) {
						uId = decodeURIComponent(uId);
					}
				} catch (e) { }
				let folUpId = parentMap?.get('folUpId') || '';
				try {
					if (folUpId) {
						folUpId = decodeURIComponent(folUpId);
					}
				} catch (e) { }
				if (this.apptId != uId || this.category != folder) {
					refresh = true;
				}
				this.apptId = uId;
				this.followUpId = folUpId;
				this.category = folder;
				if (refresh) {
					this.init();
				}
			})
		).subscribe();
	}

	init() {
		if (!this.apptId) {
			this.getMailCount();
		}
		try {
			this.searchControl.setValue(null, { emitEvent: false });
			if (this.category != "") {
				this.formCtrlSub = this.searchControl.valueChanges.pipe(debounceTime(1000)).subscribe(newValue => {
					this.refreshMails(true);
				});
			}
		} catch (error) { }
		this.allChecked = false;
		this.refreshMails(true);
		this.apiService.sendCountChangeEvent();
	}

	ngAfterViewInit(): void {
		this.apiService.viewportData$.subscribe((data) => {
			try {
				this.viewport.checkViewportSize();
			} catch (error) { }
		})
		/* this.apiService.attChangedData$.subscribe((data) => {
			if (data && data.id) {
				for (let i = 0; i < this.mailList.length; i++) {
					if (data.id == this.mailList[i].id) {
						this.mailList[i].attachmentsArr = JSON.parse(data.attachment);
					}
				}
			}
		}) */
	}

	ngOnDestroy() {
		try {
			this.formCtrlSub.unsubscribe();
		} catch (error) { }
	}

	clearFilter() {
		this.searchControl.setValue(null);
	}

	loadMails(isSearch: boolean) {
		if (!this.isListFinished && !this.isListLoading) {
			if (this.category) {
				this.isListLoading = true;
				let data: any = {
					page: this.mailStart,
					limit: this.mailLimit
				}
				if (this.searchControl.value) {
					data["search"] = this.searchControl.value;
				}
				if (this.category == "unlinked") {
					data.email_status = "unlink";
				} else if (this.category == "draft") {
					data.email_status = "draft";
				} else if (this.category == "outgoing") {
					data.email_status = "sent";
				} else if (this.category == "spam") {
					data.spam = "1";
				}
				this.apiService.getMails(data).subscribe({
					next: (data: any) => {
						this.isListLoading = false;
						let mails: any = data.data;
						for (var i = 0; i < mails.length; ++i) {
							mails[i] = this.processMail(mails[i]);
						}
						if (mails.length == this.mailLimit) {
							this.mailStart++;
						} else {
							this.isListFinished = true;
						}
						if (isSearch) {
							this.mailList = [];
						}
						this.mailList = this.mailList.concat(mails);
					}, error: (error) => {
						this.isListLoading = false;
						this.isListFinished = true;
					}
				});
			} else if (this.apptId) {
				this.isListLoading = true;
				let data: any = {
					event_id: this.apptId,
				}
				this.apiService.getMails(data).subscribe({
					next: (data: any) => {
						this.isListLoading = false;
						let mails: any = data.data;
						for (var i = 0; i < mails.length; ++i) {
							mails[i] = this.processMail(mails[i]);
						}
						this.mailList = mails;
					}, error: (error) => {
						this.isListLoading = false;
					}
				});
			}
		}
	}

	processMail(mail: any) {
		try {
			let toEmails: any = mail.to_email;
			mail.toEmailList = JSON.parse(toEmails);
		} catch (error) { }
		try {
			if (typeof mail.attachment_url == "string") {
				mail.attachmentsArr = JSON.parse(mail.attachment_url);
			} else {
				mail.attachmentsArr = mail.attachment_url || [];
			}
		} catch (error) {
			mail.attachmentsArr = [];
		}
		mail.messageDate = mail.messageDate = moment.parseZone(mail.message_date).toDate();
		// mail.messageDate = moment.parseZone(mail.message_date).format("DD-MM-YYYY HH:mm");
		return mail;
	}

	/* getAttClass(mail: any) {
		if (!mail.event_id || mail.email_status == "draft") {
			return true;
		}
		let is_used = false;
		try {
			if (mail.attachmentsArr && mail.attachmentsArr.length) {
				for (let i = 0; i < mail.attachmentsArr.length; i++) {
					if (mail.attachmentsArr[i].used_in_bill) {
						is_used = true;
					}
				}
			}
		} catch (error) { }
		return is_used;
	} */

	refreshMails(isSearch: boolean) {
		this.mailList = [];
		this.mailStart = 1;
		this.isListFinished = false;
		this.loadMails(isSearch);
	}

	getMailCount() { }

	onActivate(event: any) {
		this.showSelectMailMsg = false;
	}

	onDeactivate(event: any) {
		this.showSelectMailMsg = true;
		/* if (this.apptId) {
			this.refreshMails(true);
		} */
	}

	openMoveMailModal() {
		let mailsToMove: any[] = [];
		for (let i = 0; i < this.mailList.length; i++) {
			if (this.mailList[i].selected == true) {
				mailsToMove.push(this.mailList[i].id);
			}
		}
		if (mailsToMove.length == 0) {
			this.toastr.error("Please select mails", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		var msg = "Are you sure you want to mark selected mail";
		mailsToMove.length == 1 ? msg += "" : msg += "s";
		msg += ' as ';
		this.category == 'spam' ? msg += "<strong>not spam</strong>?" : msg += "<strong>spam</strong>?";
		Swal.fire({
			title: 'Please confirm',
			html: msg,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes'
		}).then((result) => {
			if (result.value) {
				let data: any = {
					"mail_ids": mailsToMove,
					"spam": this.category == 'spam' ? false : true
				}
				this.loaderMoveMail = true;
				this.apiService.changeSpamStatus(data).subscribe({
					next: (data) => {
						this.loaderMoveMail = false;
						Swal.fire('Success', 'Mails moved successfully.', 'success');
						if (this.apptId) {
							this.router.navigate(['/app/appt-details', 'no', this.apptId, this.followUpId, 'mails']);
						} else {
							const endpoint = this.category == 'spam' ? "unlinked" : "spam";
							this.router.navigate(['/app/mailbox/folder/' + endpoint]);
						}
					}, error: (error) => {
						this.loaderMoveMail = false;
						this.toastr.error("Something went wrong", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		})
	}

	showUnlinkLoader = false;
	unlinkMails() {
		var mailsToMove: any = [];
		for (let i = 0; i < this.mailList.length; i++) {
			if (this.mailList[i].selected == true) {
				mailsToMove.push(this.mailList[i].id);
			}
		}
		if (mailsToMove.length == 0) {
			this.toastr.error("Please select mails", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		Swal.fire({
			title: 'Warning',
			text: "Are you sure you want to unlink selected mails?",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes'
		}).then((result) => {
			if (result.value) {
				let payload: any = {
					"mail_ids": mailsToMove,
					"event_id": atob(this.apptId)
				};
				this.showUnlinkLoader = true;
				this.apiService.unlinkMail(payload).subscribe({
					next: (data: any) => {
						this.showUnlinkLoader = false;
						this.toastr.success("Mail unlinked successfully.", 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						if (this.apptId) {
							this.router.navigate(['/app/appt-details', 'no', this.apptId, this.followUpId, 'mails']);
							this.refreshMails(true);
						} else {
							this.router.navigate(['/app/mailbox/folder/' + this.category]);
						}
					}, error: (error: any) => {
						this.showUnlinkLoader = false;
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		})
	}

	selectAll() {
		this.mailList.map((mail) => mail.selected = this.allChecked);
		setTimeout(() => {
			this.apiService.setViewportData(true);
		}, 100);
	}

	selectMail() {
		setTimeout(() => {
			this.apiService.setViewportData(true);
		}, 100);
	}

	isMailSelected() {
		return this.mailList.filter((mail) => mail.selected).length;
	}

	linkMails() {
		var idList: any = [];
		for (let i = 0; i < this.mailList.length; i++) {
			if (this.mailList[i].selected == true) {
				idList.push(this.mailList[i].id);
			}
		}
		if (idList.length == 0) {
			this.toastr.error("Please select mails", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		} else {
			Swal.fire({
				title: 'Warning',
				text: "Are you sure you want to link selected mails?",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Yes'
			}).then((result) => {
				if (result.value) {
					this.router.navigate(['/app/list-appointment'], {
						queryParams: { mails: idList.join("-") }
					});
				}
			})
		}
	}

	getInitials(name: string) {
		if (name) {
			try {
				let nameArr: any[] = name.split(" ");
				for (let i = 0; i < nameArr.length; i++) {
					nameArr[i] = nameArr[i][0];
				}
				return nameArr.join("");
			} catch (error) {
				return name;
			}
		} else {
			return "";
		}
	}

	mailAction: any = null;
	showMailActions(mail: any) {
		this.mailAction = mail;
		$("#mailActionModal").modal("show");
	}

	prepareRoute(outlet: RouterOutlet) {
		return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
	}

	getMailLink(mailId: any) {
		if (this.category) {
			return ['/app/mailbox/folder', this.category, mailId];
		} else {
			return ['/app/appt-details', 'no', this.apptId, this.followUpId, 'mails', mailId];
		}
	}

	markRepliedLoader = false;
	markCaseMailsAsReplied() {
		Swal.fire({
			title: 'Warning',
			text: "Are you sure you want to mark all mails in this case as replied?",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes'
		}).then((result) => {
			if (result.value) {
				this.markRepliedLoader = true;
				this.apiService.markAllMailsAsReplied(atob(this.apptId)).subscribe({
					next: (data: any) => {
						this.markRepliedLoader = false;
						this.toastr.success("All mails marked as replied", 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}, error: (error: any) => {
						this.markRepliedLoader = false;
						this.toastr.error("Something went wrong", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				})
			}
		})
	}

	itemSize = 62;
	buffer = 0;
	scrollEvent(e: any) {
		/* if (e + 7 >= this.mailList.length && !this.vesselId) {
			this.loadMails(false);
		} */
		const total = this.mailList.length;
		const viewPortSize = this.viewport.getViewportSize();
		const visibleCount = Math.ceil(
			viewPortSize / this.itemSize
		);
		if ((e + visibleCount + this.buffer) >= total && !this.apptId) {
			this.loadMails(false);
		}
	}
}
